<template>
    <div class="bg-white shadow-sm rounded p-4">
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('wallets.label.charge_wallet')"></div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="amount" v-text="$t('wallets.label.amount_rial')"></label>
                    <input class="form-control" id="amount" name="amount" v-model="form_data.amount">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="phone" v-text="$t('label.phone')"></label>
                    <input class="form-control" id="phone" name="phone" v-model="form_data.phone">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="national_code" v-text="$t('label.national_code')"></label>
                    <input class="form-control" id="national_code" name="national_code" v-model="form_data.national_code">
                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";

    export default {
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
    }
</script>
